import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

import { BaseReportService, ConfigServerService, CustomHttp } from '../../../../core';
import { ClienteFilter } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class ClienteReportService {
    private pathApi: string;
    private pathApiReport: string;


    constructor(private customHttp: CustomHttp,
                private configServerService: ConfigServerService,
                private baseReportService: BaseReportService) {
        this.pathApi = `${configServerService.getPathApi()}/cliente`;
        this.pathApiReport = `${configServerService.getPathApiPrint()}/cliente`;
    }

    /** Realiza a impressão da ficha cadastral do cliente */
    printFichaCadastral(id: number) {
        this.customHttp.get<Blob>(`${this.pathApi}/${id}/print/fichacadastral`, { responseType: 'blob' })
            .subscribe(
                pdf => {
                    this.baseReportService.open(pdf);
                },
                error => {
                    this.baseReportService.openError(error);
                }
            )
    }

    /** Realiza a impressão da listagem dos clientes */
    printListagem(nomeImpressao: string, filter: ClienteFilter, orderBy: number, orderByDir: string): Promise<any> {
        return new Promise<void>((resolve, reject) => {
            // Params
            let params = new HttpParams()
                                .append('nomeImpressao', nomeImpressao ?? '')
                                .append('orderBy', orderBy ? orderBy.toString() : '')
                                .append('orderByDir', orderByDir ? orderByDir : '');
            // Filter params
            if (filter) {
                params = filter.createParams(params);
            }

            this.customHttp.get<Blob>(`${this.pathApiReport}/listagem`, {params, responseType: 'blob'})
                .subscribe(
                    pdf => {
                        this.baseReportService.open(pdf);
                        resolve();
                    },
                    error => {
                        this.baseReportService.openError(error);
                        reject(error);
                    }
                )
        });
    }
}
